import React from "react";
import { ArrowRight } from "lucide-react";

type ServiceItem = {
  label: string;
  onClick: () => void;
};

interface ServicesListProps {
  services: ServiceItem[];
}

const CompanyServiceCard: React.FC<ServicesListProps> = ({ services }) => {
  return (
    <div className="space-y-4">
      {services.map((service, index) => (
        <button
          key={index}
          onClick={service.onClick}
          className="flex items-center space-x-2 text-[#4F4F4F] text-left hover:text-[#143887]"
        >
          <span className="p-1 bg-[#E9ECF8] rounded">
            <ArrowRight size={16} strokeWidth={3} />
          </span>
          <span>{service.label}</span>
        </button>
      ))}
    </div>
  );
};

export default CompanyServiceCard;
